// Copyright (c) 2016 Deere & Company

import {translate} from './translation-service';

export const updateKeyValueSelectionList = (itemToAdd, isSelected, selectedList) => {

    const updatedList = selectedList.filter(item => item.key !== itemToAdd.key);

    if (isSelected) {

        return [
            ...updatedList,
            itemToAdd
        ];

    }

    return updatedList;

};

export const updateList = (itemToAdd, isSelected, key, selectedList) => {

    const selectedItemsByKey = selectedList.filter(item => item[key] !== itemToAdd[key]);

    if (isSelected) {

        return [
            ...selectedItemsByKey,
            itemToAdd
        ];

    }

    return selectedItemsByKey;

};

const allOptionsSelected = (selectedOptions, list) => selectedOptions.length === list.length;

const noOptionsSelected = selectedOptions => selectedOptions.length === 0;

/* eslint-disable complexity, max-params */

export const updateSelectionsAttribute = (state, list, valueKey, displayKey = 'name', translateValue = false) => {

    const selectedOptions = list.filter(option => state[option[valueKey]] === true);

    if (allOptionsSelected(selectedOptions, list)) {

        return {
            isLabelKey: true,
            value: 'ALL'
        };

    } else if (noOptionsSelected(selectedOptions)) {

        return {
            isLabelKey: true,
            value: 'NONE'
        };

    }

    return {
        isLabelKey: false,
        value: translateValue ?
            selectedOptions.map(currentValue => translate(currentValue[displayKey])).join(', ') :
            selectedOptions.map(currentValue => currentValue[displayKey]).join(', ')
    };

};

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/shared/services/list-selections.js